import React, { useState, useEffect, useRef } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import AppNavbar from "./components/Navbar";
import Footer from "./components/Footer";
import EmergencyModal from "./components/EmergencyModal";

import Home from "./pages/Home";
import About from "./pages/About";
import WhatWeDo from "./pages/WhatWeDo";
import Team from "./pages/Team";
import CareMap from "./pages/CareMap";
import BirdCam from "./pages/BirdCam";
import Contact from "./pages/Contact";

// Custom hook for scroll-to-top on route change
const useScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// Component that uses the scroll-to-top hook
const ScrollToTop = () => {
  useScrollToTop();
  return null;
};

// Custom hook for scroll animations
export const useFadeIn = () => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 },
    );

    const node = ref.current;

    if (node) {
      observer.observe(node);
    }

    return () => {
      if (node) {
        observer.unobserve(node);
      }
    };
  }, []);

  return [ref, isVisible];
};

function App() {
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  return (
    <Router>
      <ScrollToTop />
      <AppNavbar handleShowModal={handleShowModal} />
      <main>
        <Routes>
          <Route
            path="/"
            element={<Home handleShowModal={handleShowModal} />}
          />
          <Route path="/about" element={<About />} />
          <Route path="/what-we-do" element={<WhatWeDo />} />
          <Route path="/team" element={<Team />} />
          <Route path="/care-map" element={<CareMap />} />
          <Route path="/bird-cam" element={<BirdCam />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
      <EmergencyModal show={showModal} handleClose={handleCloseModal} />
    </Router>
  );
}

export default App;
